<template>
    <div class="modal-overlay">
        <div class="modal-content proc-modal-large">
            <h3>Vincular Modelo</h3>

            <input
                type="text"
                v-model="filtro"
                placeholder="Pesquisar modelo..."
                class="row-space"
            />

            <div class="proc-modal-list">
                <div
                    v-for="item in listaFiltrada"
                    :key="item.id"
                    class="proc-modal-item"
                    @click="$emit('confirm', item)"
                >
                    <strong>{{ item.nmepdocmodelo }}</strong>
                    <span>{{ item.cdmodelo }} - {{ item.titulo }}</span>
                </div>
            </div>

            <div class="row-end margin-top10">
                <button type="button" class="btn-cancel" @click="$emit('close')">
                    Fechar
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
    lista: {
        type: Array,
        required: true
    },
    vinculados: {
        type: Array,
        default: () => []
    }
});

defineEmits(['close', 'confirm']);

const filtro = ref('');

const idsVinculados = computed(() =>
    props.vinculados
        .filter(x => x.ativo !== 'N')
        .map(x => Number(x.idepdocmodelo))
);

const listaFiltrada = computed(() => {
    const f = filtro.value.toLowerCase().trim();

    return props.lista
        .filter(x => !idsVinculados.value.includes(Number(x.id)))
        .filter(x => {
            if (!f) return true;

            return `${x.cdmodelo} ${x.nmepdocmodelo} ${x.titulo}`
                .toLowerCase()
                .includes(f);
        });
});
</script>